import { Box, Copy, Optional, FloaterTooltipMarkdown, Icon } from '@honda-canada/design-system-react';
import React from 'react';
import themeStyles from '../styles/Card.styles';
const DriveRangeWrapper = themeStyles.apply(Box, 'DriveRangeWrapper');
const DriveRangeCopy = themeStyles.apply(Copy, 'DriveRangeCopy');
const StyledTooltip = themeStyles.apply(FloaterTooltipMarkdown, 'StyledTooltip');
const DriveRangeContainer = themeStyles.apply(Box, 'DriveRangeContainer');
const CardDriveRange = (props) => {
    const { driveRange, driveRangeTooltip } = props;
    return (React.createElement(DriveRangeContainer, null,
        React.createElement(Optional, { when: driveRange },
            React.createElement(DriveRangeWrapper, { "data-testid": "cy-uni-card-driverange" },
                React.createElement(DriveRangeCopy, { size: "extraSmall" }, driveRange),
                React.createElement(StyledTooltip, { content: driveRangeTooltip, "data-testid": "cy-driveRange-tooltip" }, ({ active }) => React.createElement(Icon, { name: "information", filled: active }))))));
};
export default CardDriveRange;
